import type { TenantBranding } from '../types';

export const DEFAULT_BRANDING_CONFIG: TenantBranding = {
  id: undefined,
  tenantId: undefined,
  commentColor: '#3B82F6',
  internalCommentColor: '#F59E0B',
  systemMessageColor: '#6B7280',
  changeRecordColor: '#10B981',
  logoUrl: undefined,
  primaryColor: undefined,
  secondaryColor: undefined,
  accentColor: undefined,
  backgroundColor: undefined,
  surfaceColor: undefined,
  textColor: undefined,
  themeBase: 'light',
};

export const DEFAULT_LIGHT_THEME_COLORS = {
  primary: '#0ea5e9',
  secondary: '#ffffff',
  accent: '#0369a1',
  background: '#f8fafc',
  surface: '#ffffff',
  text: '#0f172a',
} as const;

export const DEFAULT_DARK_THEME_COLORS = {
  primary: '#38bdf8',
  secondary: '#1f2937',
  accent: '#7dd3fc',
  background: '#111827',
  surface: '#1f2937',
  text: '#f3f4f6',
} as const;
